import React from 'react';
import dayjs from 'dayjs';

export const getDepositColumns = (renderActions) => [
  {
    title: 'Mã đặt cọc',
    dataIndex: 'id',
    key: 'id',
    fixed: 'left',
    width: 140,
  },
  {
    title: 'Mã đặt xe',
    dataIndex: 'book_code',
    key: 'book_code',
    fixed: 'left',
    width: 113,
  },
  {
    title: 'Tên khách hàng',
    dataIndex: ['book', 'cstm_name'],
    key: 'cstm_name',
    fixed: 'left',
    width: 120,
    render: (v) => v || '-',
  },
  {
    title: 'Số tiền đặt cọc',
    dataIndex: 'deposit_amount',
    align: 'center',
    width: 100,
    align: 'center',
    render: (v, r) => `${v?.toLocaleString('vi-VN')} ${r.currency || 'VND'}`,
  },
  {
    title: 'Ngày đặt cọc',
    dataIndex: 'deposit_date',
    width: 110,
    align: 'center',
    render: (v) => (v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '-'),
  },
  {
    title: 'Phương thức thanh toán',
    width: 110,
    align: 'center',
    dataIndex: 'payment_method',
  },

  /** ✅ STATUS MAPPING GIỮ NGUYÊN FIELD */
  {
    title: 'Trạng thái',
    dataIndex: 'status',
    width: 130,
    render: (v) => {
      const map = {
        0: 'Đang xử lý',
        1: 'Chờ thanh toán',
        2: 'Uỷ quyền',
        3: 'Đã thu tiền',
        4: 'Đã hoàn tiền',
        5: 'Đã hủy',
        6: 'Đã voided',
      };

      const color = {
        0: 'orange',
        1: 'orange',
        2: 'blue',
        3: 'green',
        4: 'purple',
        5: 'red',
        6: 'red',
      };

      return (
        <span style={{ color: color[v] ?? 'black' }}>
          {map[v] ?? 'Không xác định'}
        </span>
      );
    },
  },

  {
    title: 'Ngày hoàn tiền',
    dataIndex: 'refund_date',
    width: 110,
    align: 'center',
    render: (v) => (v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '-'),
  },
  {
    title: 'Số tiền hoàn',
    dataIndex: 'refund_amount',
    align: 'right',
    width: 120,
    align: 'center',
    render: (v) => (v ? v.toLocaleString('vi-VN') : '-'),
  },
  {
    title: 'Phương thức hoàn tiền',
    dataIndex: 'refund_method',
    width: 110,
    align: 'center',
  },
  { title: 'Ghi chú', dataIndex: 'note', width: 200 },

  /** ✅ ACTION BUTTON — GIỮ NGUYÊN */
  {
    title: 'Thao tác',
    key: 'actions',
    width: 220,
    fixed: 'right',
    align: 'center',
    render: (_, rec) => renderActions(rec),
  },
];
